import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BASE_URL } from 'baseConfig';
const token = localStorage.getItem('token')


export const adsServiceApi = createApi({
    reducerPath: 'adsServiceApi',
    baseQuery: fetchBaseQuery({ baseUrl: `${BASE_URL}` }),
    tagTypes: ['Ads'],
    endpoints: (builder) => ({

        getAllAds: builder.query({
            query: () => `/v1/ads`,
            providesTags: ['Ads'],
        }),
        getAllProviderAds: builder.query({
            query: (id) => `/v1/ads/getByProviderId/${id}`,
            providesTags: ['Ads'],
        }),

        createAds: builder.mutation({
            query: (values) => ({
                url: `/v1/ads`,
                method: 'POST',
                body: values,
                headers: {
                    'authorization': token,
                    'Content-Type': 'application/json',
                },
            }),
            invalidatesTags: ['Ads'],
        }),

        updateAds: builder.mutation({
            query: ({id, ...values}) => ({
              url: `/v1/ads/${id}`,
              method: 'PUT',
              headers: {
                'authorization': token,
                'Content-Type': 'application/json',
            },
              body: values,
            }),
            invalidatesTags: ['Ads'],
          }),

        deleteAds: builder.mutation({
            query: (id) => ({
                url: `/v1/ads/${id}`,
                method: 'DELETE',
                headers: {
                    'authorization': token,
                    'Content-Type': 'application/json',
                },
            }),
            invalidatesTags: ['Ads'],
        }),
    }),
});

export const {useCreateAdsMutation, useDeleteAdsMutation, useGetAllAdsQuery, useUpdateAdsMutation, useGetAllProviderAdsQuery} = adsServiceApi;